<template>
  <app-select v-model="value"
              :data-title="$t('message.leads.message.dataBase')"
              :data-menu-heading="$t('message.leads.message.dataBase')"
              data-menu-width="290px"
              :data-button-gradient="true"
              :data-items="list"
              :infiniteId="infiniteId"
              :small="small"
              infinite-loading
              :no-results="noResults"
              @search="v => search(v)"
              @load="loadMore"
              @opened="onOpened"
              @hidden="emitHidden" />
</template>

<script>
import AppSelect from "@components/Select";
import filter from "@mixins/filter";
import _ from "lodash";

export default {
  components: {
    AppSelect,
  },

  data() {
    return {
      text: "",
      searchedText: undefined,
      key: "leads",
      list: [],
      page: 0,
      infiniteId: Date.now(),
      isComplete: false,
      noResults: false,
    };
  },

  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    emitHidden() {
      this.$emit("hidden");
    },
    async loadMore($state) {
      if (this.isComplete) {
        $state.loaded();
        $state.complete();
        return;
      }

      const databases = await this.$api.leads.listDatabases({
        page: this.page,
        search: this.searchedText,
      });

      const list = _.map(databases, (externalDatabase) => {
        return {
          id: externalDatabase.id,
          label: externalDatabase.sourceIdentifier,
        };
      });

      this.list.push(...list);

      this.page += 1;

      if ($state) {
        if (list.length) {
          $state.loaded();
        } else {
          this.isComplete = true;
          $state.complete();
        }
      }
    },
    search(search) {
      this.searchedText = search;
      this.reload();
    },
    reload() {
      this.isComplete = false;

      this.page = 0;

      this.list = [];
      this.infiniteId++;
    },
    onOpened() {
      this.reload();

      this.$emit("opened");
    },
  },

  mixins: [filter],
};
</script>

<style scoped>
</style>
